import { WRStatus } from "../../local_modules/voyage-suggested-routes/src/helper";
import { WeatherRoutingInfo } from "../models/voyage-routing-model";
import { authFetchFile, authFetchGET, authFetchPUT } from "../utils/auth-fetch";


const scheduleEnv = (<any>window)['appenv'].services.schedulesapi
const WeatherRoutingEnv = (<any>window)["appenv"].services.weatherRoutingApi;
const PlansApiEnv = (<any>window)['appenv'].services.vesselplansapi;

export class WeatherRoutingService {
    static async getWRAdvice(id: string): Promise<any> {
        const url: string = `${PlansApiEnv.baseurl}/wradvise/${id}`;
        try {
            const response = await authFetchGET(PlansApiEnv.scope, url);

            if (Array.isArray(response) && response.length === 0) {
                return null;
            } else {
                return response;
            }
        } catch (error) {
            console.warn(
                "There has been a problem with your fetch operation:",
                error
            );
        }
    }

    static async getWrAdviceAvailibilty(): Promise<any> {
        const url : string = `${WeatherRoutingEnv.baseurl}/WeatherAdvice/GetUnreadAdvices`;

        try {
            const response = await authFetchGET(WeatherRoutingEnv.scope, url);

            if (Array.isArray(response) && response.length === 0) {
                return null;
            } else {
                return response;
            }
        } catch (error) {
            console.warn(
                "There has been a problem with your fetch operation:",
                error
            );
        }
    }

    static async updateWRStatus(WrId: string, status: WRStatus, weatherRoutingInfo: WeatherRoutingInfo): Promise<any> {
        const url: string = `${WeatherRoutingEnv.baseurl}/WeatherAdvice/${WrId}/status/${status}`;

        const payload: WeatherRoutingInfo = weatherRoutingInfo

        try {
            const response = await authFetchPUT(WeatherRoutingEnv.scope, url, payload);

            if (Array.isArray(response) && response.length === 0) {
                return null;
            } else {
                return response;
            }
        } catch (error) {
            console.warn(
                "There has been a problem with your fetch operation:",
                error
            );
        }
    }

    static async getWRStatus(
        departureTerminalCode: string,
        arrivalTerminalCode: string,
        scheduleId: string,
    ) : Promise<any> {
        const url: string = `${scheduleEnv.baseurl}/weatherroutingstatus?departureTerminalCode=${departureTerminalCode}&arrivalTerminalCode=${arrivalTerminalCode}&scheduleId=${scheduleId}`
        try {
            const response = await authFetchGET(scheduleEnv.scope, url)

            if (Array.isArray(response) && response.length === 0) {
                return null
            } else {
                return response
            }
        } catch (error) {
            console.warn(
                'There has been a problem with your fetch operation:',
                error,
            )
        }
    }

    static async getWRPdf(id: string): Promise<Blob | null> {
        const url: string = `${WeatherRoutingEnv.baseurl}/WeatherAdvicePdf/${id}`;
    
        try {
            // Use the new authFetchFile function
            const response = await authFetchFile(WeatherRoutingEnv.scope, url);
    
            // Convert response to Blob
            const fileBlob = await response.blob();
    
            return fileBlob;
        } catch (error) {
            console.error('Error fetching the PDF:', error);
            return null;
        }
    }


    static async checkIfPdfisAvailable(departureTerminalCode: string): Promise<any> {
        const url: string = `${WeatherRoutingEnv.baseurl}/WeatherAdvice/DepartureTerminal/${departureTerminalCode}`;
        try {
            const response = await authFetchGET(WeatherRoutingEnv.scope, url);
            return response;
        } catch (error) {
            console.error('Error checking if PDF is available:', error);
            return null;
        }
    }

    static async getWRProgress(auditId: string): Promise<any> {
        const url: string = `${WeatherRoutingEnv.baseurl}/Progress?auditId=${auditId}`;
        try {
            const response = await authFetchGET(WeatherRoutingEnv.scope, url);

            if (Array.isArray(response) && response.length === 0) {
                return null;
            } else {
                return response;
            }
        } catch (error) {
            console.warn(
                "There has been a problem with your fetch operation:",
                error
            );
            return null;
        }
    }

    static async hasWRAdviseForSchedule(scheduleId: string): Promise<boolean> {
        const url: string = `${PlansApiEnv.baseurl}/wradvise/schedule/${scheduleId}`;
        try {
            const response = await authFetchGET(PlansApiEnv.scope, url);
            // Response structure: {route: null} when no advise exists
            // Returns true if WR advise exists (route is not null)
            return response && response.route !== null;
        } catch (error) {
            console.warn(
                "Error checking WR advise for schedule:",
                error
            );
            return false;
        }
    }
}
